var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fuwu"},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/renew/fuwuinfo.png"),"alt":""}}),_c('img',{staticClass:"gostore",attrs:{"src":require("@/assets/renew/gostore.png")},on:{"click":_vm.gostore}})])}
var staticRenderFns = []

export { render, staticRenderFns }